import React from 'react';
import { useTranslation } from 'react-i18next';

const InvoiceLineProductHeader = () => {
  // translations
  const tLabels = useTranslation("invoice\\invoice").t;

  return (
    <div className="text-muted font-weight-bold pr-5">
      <div className="row no-gutters align-items-center">
        <div className="col">
          <div className="row no-gutters align-items-center">
            <div className="col">
              <div className="d-flex flex-sm-column flex-lg-row align-items-start align-items-lg-center">
                {tLabels("invoiceLineProductHeader.description")}
              </div>
            </div>
            <div className="col-auto pl-3 mr-n5 mr-sm-0">
              {tLabels("invoiceLineProductHeader.totalWithoutTax")}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceLineProductHeader;
